import Page from "@/modules/layout/internal/components/Page.vue";
import PublicPage from "@/modules/layout/public/components/Page.vue";

import generalRoutes from "@/modules/general/routes";
import accountPublicRoutes from "@/modules/account/routes-public";
import customerPreviewRoutes from "@/modules/customer-preview/routes";
import messagingRoutes from "@/modules/messaging/routes";
import plushieRoutes from "@/modules/plushie/routes";

let publicRoutes: any[] = [];

publicRoutes = publicRoutes.concat(accountPublicRoutes, generalRoutes);

let internalRoutes: any[] = [];

internalRoutes = internalRoutes.concat(
  customerPreviewRoutes,
  messagingRoutes,
  plushieRoutes
);

const baseRoutes: any[] = [
  {
    path: "/",
    component: Page,
    children: internalRoutes,
    meta: {
      auth: true,
    },
  },
  {
    path: "/",
    component: PublicPage,
    children: publicRoutes,
  },
];

export default baseRoutes;
